import * as types from "./actionTypes";

export const getRequest = id => {
  return {
    type: types.PETTY_CASH_GET_REQUEST,
    id
  };
};
export const getRequestSuccess = data => {
  return {
    type: types.PETTY_CASH_GET_SUCCESS,
    payLoad: data
  };
};
export const getRequestFailure = () => {
  return {
    type: types.PETTY_CASH_GET_FAILURE
  };
};

export const getDetail = id => {
  return {
    type: types.PETTY_CASH_DETAIL_REQUEST,
    id
  };
};
export const getDetailSuccess = data => {
  return {
    type: types.PETTY_CASH_DETAIL_SUCCESS,
    payLoad: data
  };
};
export const getDetailFailure = () => {
  return {
    type: types.PETTY_CASH_DETAIL_FAILURE
  };
};
export const getDetailClear = () => {
  return {
    type: types.PETTY_CASH_DETAIL_CLEAR
  };
};

export const list = params => {
  return {
    type: types.PETTY_CASH_LIST_REQUEST,
    params
  };
};
export const listSuccess = data => {
  return {
    type: types.PETTY_CASH_LIST_SUCCESS,
    payLoad: data
  };
};
export const listFailure = () => {
  return {
    type: types.PETTY_CASH_LIST_FAILURE
  };
};

export const store = data => {
  return {
    type: types.PETTY_CASH_STORE_REQUEST,
    data
  };
};
export const storeSuccess = () => {
  return {
    type: types.PETTY_CASH_STORE_SUCCESS
  };
};
export const storeFailure = () => {
  return {
    type: types.PETTY_CASH_STORE_FAILURE
  };
};

export const update = (id, data) => {
  return {
    type: types.PETTY_CASH_UPDATE_REQUEST,
    data,
    id
  };
};
export const updateSuccess = () => {
  return {
    type: types.PETTY_CASH_UPDATE_SUCCESS
  };
};
export const updateFailure = () => {
  return {
    type: types.PETTY_CASH_UPDATE_FAILURE
  };
};

export const updateSelectArchive = (data) => {
  return {
    type: types.PETTY_CASH_SELECT_ARCHIVE_UPDATE,
    data
  };
};
export const saveLastInfo = (data) => {
  return {
    type: types.PETTY_CASH_SAVE_LAST_INFO,
    data
  };
};

export const updateState = (id, newState) => {
  return {
    type: types.PETTY_CASH_UPDATE_STATE_REQUEST,
    newState,
    id
  };
};
export const updateStateSuccess = (data) => {
  return {
    type: types.PETTY_CASH_UPDATE_STATE_SUCCESS,
    payLoad:{data}
  };
};
export const updateStateFailure = () => {
  return {
    type: types.PETTY_CASH_UPDATE_STATE_FAILURE
  };
};

export const remove = (id, goBack = false) => {
  return {
    type: types.PETTY_CASH_REMOVE_REQUEST,
    id,
    goBack
  };
};

export const removeSuccess = () => {
  return {
    type: types.PETTY_CASH_REMOVE_SUCCESS,
  };
};

export const removeFailure = () => {
  return {
    type: types.PETTY_CASH_REMOVE_FAILURE,
  };
};